var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback, useEffect } from 'react';
import { Input, Button, Icon } from '../../elements';
import { classnames, bem, use } from '../../lib';
import { useClickOnOutside } from '../../hooks';
export const EditableInput = (_a) => {
    var { value, onSave, onCancel, className, onKeyDown, onKeyPress, onChange, iconRight, highlight, dashed, noPadding, inline, header, autoFocus = true, isEditing = false, onEdit } = _a, rest = __rest(_a, ["value", "onSave", "onCancel", "className", "onKeyDown", "onKeyPress", "onChange", "iconRight", "highlight", "dashed", "noPadding", "inline", "header", "autoFocus", "isEditing", "onEdit"]);
    const [state, setState] = useState({ value, isEditing });
    useEffect(() => {
        setState(state => (Object.assign(Object.assign({}, state), { isEditing })));
    }, [isEditing]);
    useEffect(() => {
        setState(state => (Object.assign(Object.assign({}, state), { value })));
    }, [value]);
    const handleChange = useCallback((value, e) => {
        setState(state => (Object.assign(Object.assign({}, state), { value })));
        if (onChange)
            onChange(value, e);
    }, [setState, onChange]);
    const { elementRef } = useClickOnOutside(() => {
        if (onCancel)
            onCancel();
        setState(state => (Object.assign(Object.assign({}, state), { isEditing: false, value })));
    });
    const handleCancel = useCallback(() => {
        if (onCancel)
            onCancel();
        setState(state => (Object.assign(Object.assign({}, state), { isEditing: false, value })));
    }, [onCancel, setState, value]);
    const handleSave = useCallback(() => {
        if (onSave)
            onSave(state.value);
        setState(state => (Object.assign(Object.assign({}, state), { isEditing: false })));
    }, [onSave, setState, state.value]);
    const handleClick = useCallback(() => {
        if (!state.isEditing) {
            setState(state => (Object.assign(Object.assign({}, state), { isEditing: true })));
            if (onEdit)
                onEdit();
        }
    }, [state.isEditing, setState, onEdit]);
    const handleKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            setState(prev => {
                if (onSave)
                    onSave(prev.value);
                return Object.assign(Object.assign({}, prev), { isEditing: false });
            });
        }
        if (onKeyPress)
            onKeyPress(e);
    }, [setState, onSave, onKeyPress]);
    const handleKeyDown = useCallback((e) => {
        if (e.keyCode === 27 || e.keyCode === 9) {
            setState(state => (Object.assign(Object.assign({}, state), { isEditing: false, value })));
        }
        if (onKeyDown)
            onKeyDown(e);
    }, [setState, value, onKeyDown]);
    return (React.createElement("div", { className: classnames(className, bem('editable-wrapper', use(state.isEditing || isEditing, '--is-editing'), use(highlight, '--highlight'), use(dashed, '--dashed'), use(noPadding, '--no-padding'), use(inline, '--inline'), use(header, '--header'))), onClick: handleClick, ref: elementRef },
        React.createElement(Input, Object.assign({ size: "2.5" }, rest, { autoFocus: autoFocus, className: "editable-wrapper__input", value: state.value, onKeyDown: handleKeyDown, onKeyPress: handleKeyPress, onChange: handleChange, readOnly: !(state.isEditing || isEditing), fullWidth: true })),
        (state.isEditing || isEditing) && (React.createElement("div", { className: "editable-wrapper__btn-wrapper" },
            React.createElement(Button, { iconButton: true, icon: "check", className: bem('editable-wrapper__btn', '--save'), onClick: handleSave, tabIndex: -1 }),
            React.createElement(Button, { iconButton: true, icon: "close", className: bem('editable-wrapper__btn', '--cancel'), onClick: handleCancel, tabIndex: -1 }))),
        (!state.isEditing || isEditing) && iconRight && (React.createElement(Icon, { name: iconRight, className: "editable-wrapper__icon" }))));
};
//# sourceMappingURL=EditableInput.js.map